
  // if (window.location.href.includes("https://8b101n-jf.myshopify.com")) {
  //   setTimeout(function () {
  //     window.location.href = "https://www.lightheadedhelmets.com/profile";
  //   }, 3000);
  // }

const path = window.location.pathname;

if (path === "/") {
  // Homepage
  setTimeout(() => {
    window.location.href = "https://www.lightheadedhelmets.com/home";
  }, 100);
}

else if (path.startsWith("/account")) {
  // Account page
  setTimeout(() => {
    window.location.href = "https://www.lightheadedhelmets.com/profile";
  }, 100);
}
// else if (path.startsWith("/cart")) {
//   // Account page
//   setTimeout(() => {
//     window.location.href = "https://www.lightheadedhelmets.com/cart";
//   }, 100);
// }